// ======================================================================
// File Name       : MultiLanguageProcessDetailContainer
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import React from 'react';
import { Button, Col } from 'react-bootstrap';
import { connect } from 'react-redux';
import { isInvalid, reduxForm } from 'redux-form';
import * as MultiLanguageAction from '../../actions/MultiLanguageAction';
import Header from '../../components/Header';
import MultiLanguageResultDetail from '../../components/multiLanguage/MultiLanguageResultDetail';
import * as Path from '../../constants/PathConstants';
import CustomLink from '../../components/button/CustomLink';

class MultiLanguageProcessDetailContainer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      multiLanguageProcessResultInfo: {
        multiLanguageProcessManagementIdAuto: 0,
        processStatus: 0,
        processType: '',
        processStartTime: '',
        processEndTime: '',
        languageCode: '',
        documentInfo: {},
        errorList: '',
      },
    };
  }

  componentWillMount() {
    const { match } = this.props;
    this.props.dispatch(MultiLanguageAction.getMultiLanguageProcessDetail(match.params.id));
  }

  render() {
    const { multiLanguageProcessResultInfo } = this.props;
    return (
      <div>
        <CustomLink
          className="margin-right-7 url-list"
          to={Path.MULTI_LANGUAGE_PROCESS_RESULT_LIST}
          text="処理結果一覧に戻る"
          icon="bi bi-chevron-left"
        />
        <Header name="処理結果詳細" />
        <MultiLanguageResultDetail
          multiLanguageProcessResultInfo={multiLanguageProcessResultInfo}
        />
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const {
    multiLanguageProcessResultInfo,
  } = state.multiLanguage;
  const invalid = isInvalid('multiLanguageProcessDetailForm')(state);
  return {
    ...{ multiLanguageProcessResultInfo },
    initialValues: multiLanguageProcessResultInfo,
    invalid,
  };
};

export default connect(mapStateToProps)(reduxForm({
  form: 'multiLanguageProcessDetailForm', // a unique identifier for this form
  touchOnChange: true,
})(MultiLanguageProcessDetailContainer));
